/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { formatReplyDate } from '../formatDate';

class Reply extends React.Component {
  userName(user) {
    if (user.fullName) {
      return user.fullName;
    } else if (user.email != null) {
      return user.email;
    } else {
      return user.id;
    }
  }

  render() {
    let text = this.props.reply.action.value;
    if (this.props.reply.action.kind === 'text') {
      ({ text } = this.props.reply);
    }
    return (
      <div className="flex items-start gap-2 py-1.5 px-2.5 my-0.5 bg-gray-50 rounded-md border border-gray-100 hover:bg-gray-100 transition-colors duration-150">
        <div className="flex-shrink-0 w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center text-[10px] font-medium text-primary">
          {this.userName(this.props.reply.user).charAt(0).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-1.5 flex-wrap">
            <span className="font-medium text-xs text-gray-900">
              {this.userName(this.props.reply.user)}
            </span>
            <span className="text-[10px] text-gray-500">
              {formatReplyDate(this.props.reply.createdAt)}
            </span>
          </div>
          <p className="text-xs text-gray-700 mt-0.5">{text}</p>
        </div>
      </div>
    );
  }
}

Reply = createFragmentContainer(Reply, {
  reply: graphql`
    fragment Reply_reply on Reply {
      action {
        id
        value
        kind
      }
      createdAt
      text
      id
      user {
        id
        fullName
        email
      }
    }
  `,
});

export default Reply;
